import React from 'react';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary-600 mx-auto mb-4"></div>
        <p className="text-lg text-gray-600">Loading...</p>
        <p className="text-sm text-gray-500 mt-2">Initializing RAG System</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
